import { BuiltInPlan } from "../lib/workout";
import base_pfitzinger_30 from "./plans/base_pfitzinger_30";
import base_pfitzinger_45 from "./plans/base_pfitzinger_45";
import base_pfitzinger_60 from "./plans/base_pfitzinger_60";
import five_couch from "./plans/five_couch";
import half_hansons_advanced from "./plans/half_hansons_advanced";
import half_hansons_beginner from "./plans/half_hansons_beginner";
import half_pfitzinger_12_63 from "./plans/half_pfitzinger_12_63";
import half_pfitzinger_12_84 from "./plans/half_pfitzinger_12_84";
import marathon_hansons_advanced from "./plans/marathon_hansons_advanced";
import marathon_hansons_beginner from "./plans/marathon_hansons_beginner";
import marathon_higdon_advanced_1 from "./plans/marathon_higdon_advanced_1";
import marathon_higdon_advanced_2 from "./plans/marathon_higdon_advanced_2";
import marathon_higdon_intermediate_1 from "./plans/marathon_higdon_intermediate_1";
import marathon_higdon_intermediate_2 from "./plans/marathon_higdon_intermediate_2";
import marathon_higdon_novice_1 from "./plans/marathon_higdon_novice_1";
import marathon_pfitzinger_12_55 from "./plans/marathon_pfitzinger_12_55";
import marathon_pfitzinger_12_70 from "./plans/marathon_pfitzinger_12_70";
import marathon_pfitzinger_12_85 from "./plans/marathon_pfitzinger_12_85";
import marathon_pfitzinger_18_55 from "./plans/marathon_pfitzinger_18_55";
import marathon_pfitzinger_18_70 from "./plans/marathon_pfitzinger_18_70";
import marathon_pfitzinger_18_85 from "./plans/marathon_pfitzinger_18_85";
import template_kms from "./plans/template_kms";
import template_miles from "./plans/template_miles";

export const PLANS: BuiltInPlan[] = [
  marathon_pfitzinger_12_55,
  marathon_pfitzinger_18_55,
  marathon_pfitzinger_12_70,
  marathon_pfitzinger_18_70,
  marathon_pfitzinger_12_85,
  marathon_pfitzinger_18_85,
  marathon_hansons_beginner,
  marathon_hansons_advanced,
  marathon_higdon_novice_1,
  marathon_higdon_intermediate_1,
  marathon_higdon_intermediate_2,
  marathon_higdon_advanced_1,
  marathon_higdon_advanced_2,
  half_pfitzinger_12_63,
  half_pfitzinger_12_84,
  half_hansons_beginner,
  half_hansons_advanced,
  five_couch,
  base_pfitzinger_30,
  base_pfitzinger_45,
  base_pfitzinger_60,
  template_miles,
  template_kms,
];
